import { render } from "./bannerModel.vue?vue&type=template&id=ed570d52&scoped=true&ts=true"
import script from "./bannerModel.vue?vue&type=script&lang=ts"
export * from "./bannerModel.vue?vue&type=script&lang=ts"

import "./bannerModel.vue?vue&type=style&index=0&id=ed570d52&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed570d52"]])

export default __exports__